import { QUESTIONS_URL } from '@/modules/question/question.constants';
import { resolveCurrentUser } from '@/modules/user/user.service';
import { createEmptyComponent } from '@/router/route.service';

export default [
  {
    path: QUESTIONS_URL.path,
    redirect: '/',
    beforeEnter: resolveCurrentUser,
    component: { render: createEmptyComponent },
    children: [
      {
        ...QUESTIONS_URL.view,
        component: () => import('@/modules/question/views/QuestionViewPage.vue'),
      },
      {
        ...QUESTIONS_URL.edit,
        component: () => import('@/modules/question/views/QuestionEditPage.vue'),
      },
      {
        ...QUESTIONS_URL.create,
        component: () => import('@/modules/question/views/QuestionEditPage.vue'),
      },
      {
        ...QUESTIONS_URL.forbidden,
        component: () => import('@/modules/question/views/QuestionForbidden.vue'),
      },
      {
        ...QUESTIONS_URL.notfound,
        component: () => import('@/modules/question/views/QuestionNotFound.vue'),
      },
      {
        ...QUESTIONS_URL.denied,
        component: () => import('@/modules/question/views/QuestionDenied.vue'),
      },
    ],
  },
];

export function goToDeniedQuestion($router) {
  $router.push({
    name: QUESTIONS_URL.denied.name,
  });
}

export function goToQuestionForbidden($router) {
  $router.push({
    name: QUESTIONS_URL.forbidden.name,
  });
}

export function goToQuestionNotFound($router) {
  $router.push({
    name: QUESTIONS_URL.notfound.name,
  });
}

export function goToOpenQuestion($router, question) {
  $router.push({
    name: QUESTIONS_URL.view.name,
    params: { id: question.id },
  });
}

export function goToCreateQuestion($router) {
  $router.push({
    name: QUESTIONS_URL.create.name,
  });
}
